import { useState } from 'react';
import axios from 'axios';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthPage = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, formData);
      
      toast.success('Connexion réussie !');
      onLogin(response.data.access_token, response.data.user);
    } catch (error) {
      console.error('Login error:', error);
      if (error.response?.status === 423) {
        toast.error('Vous devez d\'abord accepter votre invitation et changer votre mot de passe');
      } else {
        toast.error(error.response?.data?.detail || 'Erreur de connexion');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-black p-4">
      <Card className="w-full max-w-md shadow-2xl border-gray-200 dark:border-gray-800 dark:border-gray-800">
        <CardHeader className="space-y-3 text-center">
          <div className="mx-auto w-16 h-16 bg-slate-800 dark:bg-slate-700 rounded-2xl flex items-center justify-center">
            <span className="text-2xl">🐑</span>
          </div>
          <CardTitle className="text-3xl font-bold text-gray-900 dark:text-white">Firma</CardTitle>
          <CardDescription className="text-base">
            Connectez-vous à votre compte
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4" data-testid="auth-form">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                placeholder="vous@exemple.com"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                required
                data-testid="email-input"
                className="border-gray-200 dark:border-gray-800 focus:border-slate-500"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Mot de passe</Label>
              <Input
                id="password"
                type="password"
                placeholder="••••••••"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
                data-testid="password-input"
                className="border-gray-200 dark:border-gray-800 focus:border-slate-500"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              data-testid="auth-submit-button"
              className="w-full bg-slate-800 hover:bg-slate-900 dark:bg-slate-700 dark:hover:bg-slate-600 text-white font-medium py-5 text-base"
            >
              {loading ? 'Connexion...' : 'Se connecter'}
            </Button>
          </form>

          <div className="mt-6 text-center">
              <Link
                to="/forgot-password"
                className="text-gray-500 hover:text-gray-700 font-medium text-sm"
                data-testid="forgot-password-link"
              >
                Mot de passe oublié ?
              </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AuthPage;